import { useGetStore } from "../api/useGetStore";

export function DashboardPage() {
  const { data, isLoading, isError } = useGetStore();

  console.log({ data, isLoading, isError });

  return <p>Data loaded</p>;
}
